import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { UpdateSkAdNetworkApplicationStatusResponseActionPayload } from '../SKANPostbacksConversionMapping.types';

const UpdateSkAdNetworkApplicationStatus = new ReduxAsyncAction<
  'UPDATE_SK_AD_NETWORK_APPLICATION_STATUS',
  boolean,
  UpdateSkAdNetworkApplicationStatusResponseActionPayload
>('UPDATE_SK_AD_NETWORK_APPLICATION_STATUS');

UpdateSkAdNetworkApplicationStatus.registerRequest(async (skAdNetworkEnabled: boolean) => {
  try {
    const response = await dash_api.put<UpdateSkAdNetworkApplicationStatusResponseActionPayload>(
      '/v1/skadnetworkv2/skan-app-status',
      { skAdNetworkEnabled }
    );

    NotificationActions.showNotification(
      `We have confirmed your SK Ad Network opt-${skAdNetworkEnabled ? 'in' : 'out'}.`,
      'success'
    );

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot update Sk Ad Network Application status. Please try again.', 'error');

    throw error;
  }
});

export const UPDATE_SK_AD_NETWORK_APPLICATION_STATUS = UpdateSkAdNetworkApplicationStatus.actionNamespaceConstants;

export const updateSkAdNetworkApplicationStatus = UpdateSkAdNetworkApplicationStatus.request;

export type UpdateSkAdNetworkApplicationStatusResponseAction = Action<
  typeof UPDATE_SK_AD_NETWORK_APPLICATION_STATUS.response
> & { data: UpdateSkAdNetworkApplicationStatusResponseActionPayload };
